import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import {
  RolActividadCheckElement,
  VinculacionRolActividadInput
} from '../entity-roles/roles.model';

@Component({
  selector: 'rpe-vinculacion-rol-actividad-listado',
  templateUrl: './vinculacion-rol-actividad-listado.component.html',
  styleUrls: ['./vinculacion-rol-actividad-listado.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VinculacionRolActividadListadoComponent implements OnInit {
  @Input()
  set formInput(vinculacionRolActividadData: VinculacionRolActividadInput) {
    if (vinculacionRolActividadData != null) {
      // console.log('rolDetailFormInput vinculo', consentimientoInformadoInput);
      this._formInput = vinculacionRolActividadData;
    }
  }

  get formInput(): VinculacionRolActividadInput {
    return this._formInput;
  }

  _formInput: VinculacionRolActividadInput;

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<RolActividadCheckElement[]>();

  actividadesCheck: RolActividadCheckElement[] = [];
  checkedList: boolean[] = [];
  actividadSinCheck = false;
  sinActividades = false;

  vRALFormGroup: FormGroup = null;

  constructor(private fb: FormBuilder) {}

  // dateValidator(control: FormGroup): { [s: string]: boolean } {
  //   if (control.value) {
  //     console.log(control.value, 'fecha');
  //     const date = new Date(control.value);
  //     const today = new Date();
  //     if (date > today) {
  //       return { invalidDate: true };
  //     }
  //   }
  //
  //   return null;
  // }

  ngOnInit() {
    this.formInput.rolesActividadConNombre.forEach((rACN) => {
      this.actividadesCheck.push({
        value: true,
        rolActividadConNombre: rACN
      });
      this.checkedList.push(true);
    });

    this.vRALFormGroup = this.fb.group({
      // fecha_nacimiento: ['', [Validators.required, this.dateValidator]],
      firstCtrl: ['', Validators.required]
    });
  }

  // TODO mejorar la mecanica del check no se deberia usar una lista extra de checkedList
  // deberia ser un id del tipoActividad
  onCheckChange(event: any, indice: number) {
    this.checkedList[indice] = event.currentTarget.checked;
    this.sinActividades = true;
    this.actividadSinCheck = false;
    const auxListado: RolActividadCheckElement[] = [];

    for (let i = 0; i < this.checkedList.length; i++) {
      const auxCheck: RolActividadCheckElement = {
        ...this.actividadesCheck[i],
        value: this.checkedList[i]
      };
      if (this.checkedList[i]) {
        this.sinActividades = false;
      } else {
        this.actividadSinCheck = true;
      }
      auxListado.push(auxCheck);
    }
    this.formValueChanges.emit(auxListado);
  }

  onSubmit() {
    // if (this.form.valid) {
    //   this.save();
    //   this.dialogRef.close(this.form.value);
    // }
  }

  onCancel() {}
}
